import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { FDClickableText, FDPaper, FDStack } from '@facet-wealth/design';
import { useIsVerticalOverflow } from 'Hooks/useIsVerticalOverflow';
import { TruncatedBox } from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Common/TruncatedBox';
import { dataAttrs } from 'Helpers/Testing';

const MAX_CONTENT_HEIGHT_WHEN_TRUNCATING = 80;

const MessageDisplayBoxWithTruncation = ({ messageContent }) => {
  const [showMore, setShowMore] = useState(false);
  const verticalOverflowRef = useRef();
  const isOverflowed = useIsVerticalOverflow(verticalOverflowRef, { maxSize: MAX_CONTENT_HEIGHT_WHEN_TRUNCATING });

  return (
    <FDPaper padding={3} appearance={'flat'} color={'subtle'} width={'100%'} {...dataAttrs('message-display-box')}>
      <FDStack direction={'column'} spacing={2}>
        <TruncatedBox isTruncated={!showMore && isOverflowed} ref={verticalOverflowRef} maxContentHeightWhenTruncating={MAX_CONTENT_HEIGHT_WHEN_TRUNCATING}>
          <RichTextDisplay content={messageContent} />
        </TruncatedBox>
        {isOverflowed ? (
          <FDClickableText appearance={'standalone'} size={'sm'} onClick={() => setShowMore(!showMore)} label={!showMore ? 'View full message' : 'Minimize message'} {...dataAttrs('overflow-clickable-text')} />
        ) : null}
      </FDStack>
    </FDPaper>
  );
};

MessageDisplayBoxWithTruncation.defaultProps = {
};

MessageDisplayBoxWithTruncation.propTypes = {
  messageContent: PropTypes.string.isRequired,
};

export default MessageDisplayBoxWithTruncation;
